import ApiService from "./api.service";

export function uploadFile(formData) {
  return new Promise((resolve, reject) => {
    ApiService.upload("/common/media/uploadFile", formData)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(({ response }) => {
        reject(response);
      });
  });
}
